import { Row, Col } from "react-bootstrap";
import SearchBar from "./components/SearchBar";
import SidebarFilters from "./components/SidebarFilters";
import CourseCardBox from "./components/CourseCardBox";
import Pagination from "./components/Pagination";
import { COURSES } from "./data/Mockdata2";

// ─── SearchPage ───────────────────────────────────────────────────────────────
// Main page layout: SearchBar on top, SidebarFilters on left, course grid on right.
// Each section is a standalone component for easy maintenance.

export default function SearchPage() {
    return (
        <>
            {/* Top Search Bar */}
            <SearchBar
                activeFilters={2}
                resultCount="3,145,684"
                query="ui/ux design"
            />

            {/* Main Content: SidebarFilters + Course Grid */}
            <div className="layout-wrapper d-flex flex-column flex-lg-row gap-4">

                {/* SidebarFilters (sticky on desktop) */}
                <div className="sidebar-filters-wrapper position-sticky overflow-y-auto">
                    <SidebarFilters />
                </div>

                {/* Course Grid */}
                <div className="right-section flex-grow-1">
                    {/* 3-column responsive grid */}
                    <Row className="g-3 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-2 row-cols-xl-3">
                        {COURSES.map((course, idx) => (
                            <Col key={course.id}>
                                <CourseCardBox course={course} />
                            </Col>
                        ))}
                    </Row>

                    {/* Pagination */}
                    <Pagination totalPages={5} />
                </div>

            </div>
        </>
    );
}